import { Types } from '@store/types';

export const setCurrentBlockAction = (data) => {
	try {
		return {
			type: Types.SET_BLOCK_ACTION,
			payload: data
		};
	} catch {
		/* Empty Block */
	}
};
